export enum ArnTrackerType {
  sentry = 'sentry',
  google = 'google',
  matomo = 'matomo',
  facebook = 'facebook',
}

export interface ArnTrackerConfig {
  arnTrackerType: ArnTrackerType;
}

export interface ArnValidTrackingConfig {
  trackers: ArnTrackerConfig[];
}

export type ArnTrackingConfig = ArnValidTrackingConfig;
